import { render, staticRenderFns } from "./MarketsDetails.vue?vue&type=template&id=71381d36&scoped=true"
import script from "./MarketsDetails.vue?vue&type=script&lang=js"
export * from "./MarketsDetails.vue?vue&type=script&lang=js"
import style0 from "./MarketsDetails.vue?vue&type=style&index=0&id=71381d36&prod&lang=scss&scoped=true"
import style1 from "./MarketsDetails.vue?vue&type=style&index=1&id=71381d36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71381d36",
  null
  
)

export default component.exports